export default "__VITE_ASSET__DsEyDCEx__"